
import { useState } from "react";
import ChatContainer from "@/components/chat/ChatContainer";
import VoiceAssistant from "@/components/VoiceAssistant";

type Persona = "travel" | "health" | "meals" | "errands" | "home" | "work";

interface ChatInterfaceProps {
  selectedPersona: Persona | null;
  mode?: "chat" | "voice";
  onFullscreenChange?: (isFullscreen: boolean) => void;
}

const ChatInterface = ({ selectedPersona, mode = "chat", onFullscreenChange }: ChatInterfaceProps) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleFullscreenChange = (fullscreen: boolean) => {
    setIsFullscreen(fullscreen);
    onFullscreenChange?.(fullscreen);
  };

  return (
    <div className="flex flex-col space-y-4">
      {mode === "chat" ? (
        <ChatContainer 
          selectedPersona={selectedPersona} 
          onFullscreenChange={handleFullscreenChange}
        />
      ) : (
        <VoiceAssistant selectedPersona={selectedPersona} />
      )}
    </div>
  );
};

export default ChatInterface;
